




























































import Vue from "vue";
import Component from "vue-class-component";
import { Getter, Action } from "vuex-class";
import { Watch } from "vue-property-decorator";

const namespace = "customer";

@Component({})
export default class ModalDetail extends Vue {
  @Getter("getNotificationSent", { namespace })
  notificationSent!: boolean;

  @Action("setNotificationSent", { namespace }) setNotificationSent!: any;

  closeModal(): void {
    this.setNotificationSent(false);
  }
}
